export default {
    SET_EMPLOYEES(state, employeesList) {
        state.employeesList = [...employeesList];
    },
    SET_CLASSES(state, classList) {
        state.availableClasses = [...classList];
    },
    SET_DEPARTMENTS(state, departmentList) {
        state.availableDepartments = [...departmentList];
    },
    SET_NUMBER_OF_RESULTS(state, numberOfResults) {
        state.numberOfResults = numberOfResults;
    },
    SET_COURSES(state, courses) {
        state.courses = courses.map(item => {
            return item.permission_id;
        });
    },
}